import { Box } from '@mantine/core';
import classes from 'global.module.css';

interface ColoredCircleProps {
  size?: number;
  color: string;
  innerColor?: string;
}

export const ColoredCircle = ({ size = 16, color, innerColor }: ColoredCircleProps) => {
  const innerSize = size / 2;

  return (
    <Box
      className={classes.coloredCircle}
      style={{
        width: size,
        height: size,
        backgroundColor: color,
      }}
    >
      {innerColor && (
        <Box
          className={classes.coloredCircleInner}
          style={{
            width: innerSize,
            height: innerSize,
            backgroundColor: innerColor || color,
          }}
        />
      )}
    </Box>
  );
};
